;(function(){
  // Grab the current path
  var path = window.location.pathname || '';

  // Your normal settings object:
  var settings = {
    "program": {
      "active": true,
      "shop": "gascon-horsemanship-shop.myshopify.com",
      "incentive": {
        "type": "percentage",
        "value": "10.00",
        "price_rule_id": 1378213069111,
        "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
      },
      "program": "MTA0OTA5"
    },
    "design": {
      "refer_customer_button": {
        "refer_button_text": "Refer & Earn",
        "refer_background_color": "#1d4de8",
        "refer_text_color": "#ffffff",
        "web_position": "right-bottom",
        "mobile_position": "right-bottom"
      },
      "refer_customer_invite": {
        "popup_header": "Invite Friends & Get 10% from orders",
        "popup_description": "Send your friends a 10% discount off their purchase. Once they make a purchase, you’ll earn 10% for each order as well! This reward can be redeemed for coupons.",
        "button_text_get_invite": "Get invite link",
        "button_copy_invite": "Copy invite link",
        "popup_background_color": "#1d4de8",
        "popup_text_color": "#ffffff"
      },
      "refer_customer_incentive_popup": {
        "shop_header": "You got 10% Off",
        "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
        "shop_button_text": "Shop now",
        "shop_background_color": "#1d4de8",
        "shop_text_color": "#ffffff"
      }
    }
  };

  // 🚫 Disable this program on /pages/mg-halter-facebook (with or without trailing slash)
  if ( path.indexOf('/pages/mg-halter-facebook') === 0 ) {
    settings.program.active = false;
  }

  // Expose it for the loader script to pick up:
  window.SCAAFFCustomerReferSetting = settings;
})();
